import { observeElement, getWidget } from '@uvocore-front/utils';
import Loader from '../UI/loader';
import './styles.scss';
import config from './config';

const TestimonialsListInit = () => {
  observeElement({
    element: '[data-testimonials-container]',
    marginValue: 300,
    callback: () => {
      getWidget({
        widgetLink: '/assets/js/testimonialsWidget.min.js',
        customLoader: Loader,
        insertLoaderTo: '[data-testimonials-container]',
        fn: () => {
          window.tmWidget({
            ...config,
            callbackLoaded: () => {
              document
                .querySelector('[data-testimonials-load-more-button]')
                .classList.add('visible');
            },
          });
        },
      });
    },
  });
};

window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.testimonials')) {
    TestimonialsListInit();
  }
});
